/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <div class="app-view" :id="pageName">
    <svg-icons />
    <top-navigation></top-navigation>
    <right-navigation></right-navigation>
    <bottom-navigation></bottom-navigation>
    <left-navigation></left-navigation>
    <main role="main">
      <component :is="layout">
        <router-view :key="$route.fullPath" />
      </component>
    </main>
    <loader />
    <generic-modal />
    <quick-view />
    <version-updater />
  </div>
</template>

<script>
import Loader from 'theme/components/Loader'
import TopNavigation from 'theme/components/TopNavigation/TopNavigation'
import BottomNavigation from 'theme/components/BottomNavigation/BottomNavigation'
import RightNavigation from 'theme/components/RightNavigation/RightNavigation'
import LeftNavigation from 'theme/components/LeftNavigation/LeftNavigation'
import LayoutDefault from 'theme/pages/Layout/Default'
import LayoutNoSidebar from 'theme/pages/Layout/NoSidebar'
import SvgIcons from 'theme/assets/fonts/icons/svg-icons'
import GenericModal from 'theme/components/Modal/Generic'
import QuickView from 'theme/components/Modal/QuickView'
import VersionUpdater from 'theme/components/VersionUpdater/VersionUpdater'

const defultLayout = 'default'

export default {
  computed: {
    pageName () {
      return `page-${this.$route.name}`
    },
    layout () {
      return 'layout-' + (this.$route.meta.layout || defultLayout)
    },
    error () {
      return this.$store.state.errorHandler.error
    }
  },
  components: {
    Loader,
    TopNavigation,
    RightNavigation,
    LeftNavigation,
    LayoutDefault,
    LayoutNoSidebar,
    BottomNavigation,
    SvgIcons,
    GenericModal,
    QuickView,
    VersionUpdater
  }
}
</script>
